import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})

export class DayEndService {
    private baseURL: string;
    constructor(private http: HttpClient) {
        this.baseURL = environment.apiBaseUrl;
    }

    getDayEndTerminals(userName: string, startDate?: string, endDate?: string): Observable<any[]> {
        let params = `?userName=${encodeURIComponent(userName)}`; // mandatory
        if (startDate) params += `&startDate=${encodeURIComponent(startDate)}`;
        if (endDate) params += `&endDate=${encodeURIComponent(endDate)}`;
        return this.http.get<any[]>(
            `${this.baseURL}/DayEnd/GetDayEndTerminals${params}`,
            { observe: 'response' }
        ).pipe(
            map(res => res.body as any[]),
            catchError(this.handleError)
        );
    }

    getDayEndClosingAmount(userId: number, terminalName: string, dateTime: string, ocaNumSlNo: number, isUserwiseDayend: boolean): Observable<any> {
        const params = `?userId=${userId}&terminalName=${encodeURIComponent(terminalName)}&dateTime=${encodeURIComponent(dateTime)}&ocaNumSlNo=${ocaNumSlNo}&isUserwiseDayend=${isUserwiseDayend}`;
        return this.http.get<any>(
            `${this.baseURL}/DayEnd/GetDayEndClosingAmount${params}`,
            { observe: 'response' }
        ).pipe(
            map(res => res.body),
            catchError(this.handleError)
        );
    }

    getDayEndDetails(userId: number, terminalName: string, dateTime: string, ocaNumSlNo: number): Observable<any> {
        const params = `?userId=${userId}&terminalName=${encodeURIComponent(terminalName)}&dateTime=${encodeURIComponent(dateTime)}&ocaNumSlNo=${ocaNumSlNo}`;
        return this.http.get<any>(
            `${this.baseURL}/DayEnd/GetDayEndDetails${params}`,
            { observe: 'response' }
        ).pipe(
            map(res => res.body),
            catchError(this.handleError)
        );
    }

    saveDayEndProcess(dayEndProcessDto: any): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/DayEnd/SaveDayEndProcess`,
            dayEndProcessDto,
            { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }
        ).pipe(
            map(res => res),
            catchError(this.handleError)
        );
    }

    checkDayEndProcessForLoggedInUser(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/DayEnd/CheckDayEndProcessForLoggedInUser`,
            { observe: 'response' }
        ).pipe(
            map(res => res.body),
            catchError(this.handleError)
        );
    }

    CheckDayEndProcessForInvoice(invoiceNumber): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/DayEnd/CheckDayEndProcessForInvoice?invoiceNumber=${encodeURIComponent(invoiceNumber)}`,
            { observe: 'response' }
        ).pipe(
            map(res => res.body),
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
}
